import { useContext } from 'react';
import { onBlurContext } from './context';

export const useOnBlur = () => {
  const onBlur = useContext(onBlurContext);
  return onBlur;
};
